// extracted by mini-css-extract-plugin
export default {"matchConfigurationLandingPage":"match-configuration-landing_matchConfigurationLandingPage__wqVeS"};